import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from 'src/app/app-settings';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

@Component({
  selector: 'app-swiper-images',
  templateUrl: './swiper-images.component.html',
  styleUrls: ['./swiper-images.component.scss'],
})
export class SwiperImagesComponent implements OnInit {
  @Input() images: any[];
  @Input() idEvent: number;
  urlImages: string = AppSettings.MEDIA_URI + '/events_images/';

  swiperImagesConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,
    observer: true,           
    observeParents: true,
    updateOnWindowResize: true,
    navigation: {
      nextEl: '.button-next-custom',
      prevEl: '.button-prev-custom',
      enabled: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
    },
  };

  constructor() {}

  ngOnInit(): void {
    // Con 1 o 2 imágenes apagamos el loop para que Swiper no se buguee clonando.
    if (this.images && this.images.length <= 2) {
      this.swiperImagesConfig = {
        ...this.swiperImagesConfig,
        loop: false,
      };
    }

    // Con una sola foto no hay pareja que la acompañe: de dos en dos se
    // quedaba en la mitad izquierda con el hueco al lado, así que ocupa el
    // ancho entero (y el contenedor la pone en 16/9, ver .is-single).
    if (this.images && this.images.length === 1) {
      this.swiperImagesConfig = {
        ...this.swiperImagesConfig,
        breakpoints: {
          768: {
            slidesPerView: 1,
          },
        },
      };
    }
  }
}
